import React, {useEffect, useMemo, useState} from 'react';
import Dashboard from "../../layouts/Dashboard";
import {COMPLETION_ACT_ADD_ROUTE, COMPLETION_ACT_ROUTE} from "../../routes/const";
import BreadcrumbsShared from "../../components/Shared/BreadcrumbsShared";
import Status from "../../components/Status/Status";
import Box from "@mui/material/Box";
import {Button, CircularProgress, FormGroup, Grid, Paper, Stack, Switch} from "@mui/material";
import Typography from "@mui/material/Typography";
import {DatePickerShared, Number, SelectFieldModal, SelectShared, TableMin} from "../../components";
import TextShared from "../../components/Shared/TextShared";
import {getLegalClient} from "../../redux/actions/client/legalClientActions";
import {t} from "i18next";
import {useDispatch, useSelector} from "react-redux";
import {contractRequestModalRowName, legalClientTableRowName, personTableRowName} from "../../lang/i18n";
import {getFilial} from "../../redux/actions/filial/filialActions";
import {getContract, getOneContract} from "../../redux/actions/contract/contractActions";
import moment from "moment";
import {v4 as uuidv4} from "uuid";
import {getService} from "../../redux/actions/service/serviceActions";
import {getServiceKind, getUnitOfMeasure} from "../../redux/actions/genericActions";
import {LoadingButton} from "@mui/lab";
import {
    editCompletionAct,
    getOneCompletionAct
} from "../../redux/actions/bookkeeping/bookkeepingActions";
import {useHistory, useParams} from "react-router-dom";
import {getPersons} from "../../redux/actions/client/personActions";
import {getEmployee} from "../../redux/actions/employee/employeeActions";
import {getClients} from "../../redux/actions/client/clientActions";

function CompletionActEdit(props) {
    const dispatch = useDispatch();
    const {id} = useParams()
    const history = useHistory()
    const [number, setNumber] = useState(1)
    const [startDate, setStartDate] = useState(new Date())
    const [customerIdentity, setCustomerIdentity] = useState('')
    const {
        legalClient: legalClientRedux,
        legalClientCount: legalClientReduxCount
    } = useSelector((state) => state.legalClient);
    const {persons, personsCount} = useSelector((state) => state.person);
    const {employee, employeeCount} = useSelector((state) => state.employee);
    const {filial} = useSelector((state) => state.filial);
    const [typeClient, setTypeClient] = useState(false)
    const [customerId, setCustomerId] = useState(1)
    const [customerName, setCustomerName] = useState('')
    const [customerAddressLine, setCustomerAddressLine] = useState('')
    const [customerContactLine, setCustomerContactLine] = useState('')


    const [filialId, setFilialId] = useState(1)
    const [performerIdentity, setPerformerIdentity] = useState('')
    const [performerName, setPerformerName] = useState('')
    const [performerAddressLine, setPerformerAddressLine] = useState('')
    const [performerContactLine, setPerformerContactLine] = useState('')

    const [contractId, setContractId] = useState('')
    const [qty, setQty] = useState(1)
    const [unitOfMeasure, setUnitOfMeasure] = useState(1)
    const [localServiceKind, setLocalServiceKind] = useState(1)
    const {contracts, contractsCount} = useSelector((state) => state.contract)
    const {unityOfMeasure, serviceKind} = useSelector((state) => state.generic);
    const {anObjects, anObjectsCount} = useSelector((state) => state.anObject);
    const {servicesSchedule, servicesScheduleCount} = useSelector((state) => state.service);
    const {completionActOne} = useSelector((state) => state.bookkeeping);
    const [anObjectsLocal, setAnObjectsLocal] = useState(1)
    const [servicesScheduleLocal, setServicesScheduleLocal] = useState(1)
    const [service, setService] = useState(1)
    const {services, servicesCount} = useSelector((state) => state.service);
    const [specification, setSpecification] = useState('')

    const [customerStockUsageDescription, setCustomerStockUsageDescription] = useState('')
    const [application, setApplication] = useState('')
    const [signPerformerId, setSignPerformerId] = useState(1)
    const [signPerfomerPosition, setSignPerfomerPosition] = useState('')
    const [signPerfomerFullName, setSignPerfomerFullName] = useState('')
    const [signCustomerPosition, setSignCustomerPosition] = useState('')
    const [signCustomerFullName, setSignCustomerFullName] = useState('')
    const [signedDateTime, setSignedDateTime] = useState(new Date())

    const handleSubmit = () => {
        setLoadingAdd(true)
        dispatch(editCompletionAct(id, number, startDate, customerIdentity, customerName, customerAddressLine, customerContactLine, performerIdentity, performerName,
            performerAddressLine, performerContactLine, customerStockUsageDescription, application, signPerfomerPosition, signPerfomerFullName, signCustomerPosition,
            signCustomerFullName, signedDateTime, customerId, filialId, signPerformerId, specification, contractId, typeClient ? 'personId' : 'legalPersonId'))
        setLoadingAdd(false)
        history.push(COMPLETION_ACT_ROUTE)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleDeleteSpec = async (row) => {
        const newSpec = specification.filter(el => el.Id !== row)
        await setSpecification(newSpec);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleFormSpec = async (e) => {
        e.preventDefault()
        const localServiceKindIdx = serviceKind.findIndex(el => el.id === localServiceKind)
        const serviceIdx = services.findIndex(el => el.id === service)
        const unitOfMeasureIdx = unityOfMeasure.findIndex(el => el.id === unitOfMeasure)
        const newElement = {
            Id: uuidv4(),
            serviceKind: serviceKind[localServiceKindIdx]?.name,
            serviceKindId: localServiceKind,
            service: services[serviceIdx]?.name,
            serviceId: service,
            unitId: unitOfMeasure,
            unit: unityOfMeasure[unitOfMeasureIdx]?.name,
            quantity: qty,
            price: services[serviceIdx]?.price,
            objectId: '',
            scheduleId: ''
        }
        setSpecification(oldArray => [...oldArray, newElement])
    }

    useEffect(() => {
        (async function () {
            if (contractId) {
                const res = await dispatch(getOneContract(contractId))
                setSpecification(res?.specifications?.map(el => {
                    return {
                        Id: uuidv4(),
                        serviceKind: serviceKind.find(row => row.id === el.serviceKindId)?.name,
                        serviceKindId: el.serviceKindId,
                        service: services.find(row => row.id === el.serviceId)?.name,
                        serviceId: el.serviceId,
                        unit: unityOfMeasure.find(row => row.id === el.unitId)?.name,
                        unitId: el.unitId,
                        quantity: el.quantity,
                        price: el.price,
                        objectId: el.objectId,
                        scheduleId: el.scheduleId
                    }
                }))
            }
        }())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contractId])

    const RenderTableMin = useMemo(() => {
        if (!contractId) return false
        return (
            <Box component={Paper} sx={{mt: 5, display: 'flex', padding: '0px 10px', flexWrap: 'wrap'}}>
                <TableMin edit servicesCount={servicesCount}
                          handleDeleteSpec={handleDeleteSpec}
                          unityOfMeasure={unityOfMeasure} setUnitOfMeasure={setUnitOfMeasure}
                          unitOfMeasure={unitOfMeasure}
                          services={services.map(el => ({id: el.id, name: el.name, price: el.price}))}
                          setService={setService} service={service} serviceKind={serviceKind}
                          setLocalServiceKind={setLocalServiceKind} localServiceKind={localServiceKind}
                          setQty={setQty} qty={qty} setServicesScheduleLocal={setServicesScheduleLocal}
                          servicesScheduleLocal={servicesScheduleLocal} setAnObjectsLocal={setAnObjectsLocal}
                          anObjectsLocal={anObjectsLocal} servicesScheduleCount={servicesScheduleCount}
                          servicesSchedule={servicesSchedule} anObjectsCount={anObjectsCount} anObjects={anObjects}
                          setSpecification={setSpecification} specification={specification}/>
                <Button onClick={handleFormSpec}>Добавить блок</Button>
            </Box>
        )
    }, [anObjects, anObjectsCount, anObjectsLocal, contractId, handleDeleteSpec, handleFormSpec, localServiceKind, qty, service, serviceKind, services, servicesCount, servicesSchedule, servicesScheduleCount, servicesScheduleLocal, specification, unitOfMeasure, unityOfMeasure])

    useEffect(() => {
        (async function () {
            setLoading(true)
            const resService = await dispatch(getService(1, 10))
            const resUnit = await dispatch(getUnitOfMeasure(1, null, 30))
            const resServiceKind = await dispatch(getServiceKind())
            await dispatch(getFilial(1, 100))
            const res = await dispatch(getOneCompletionAct(id))
            const clients = await dispatch(getClients(1, 1, {
                filter: {
                    id: {
                        operand1: res?.customerId,
                        operator: "equals"
                    },
                }
            }))
            const client = clients?.result[0]
            if (res) {
                setApplication(res?.application)
                setContractId(res?.contractId)
                setCustomerAddressLine(res?.customerAddressLine)
                setCustomerContactLine(res?.customerContactLine)
                setCustomerIdentity(res?.customerIdentity)
                setCustomerName(res?.customerName)
                setCustomerStockUsageDescription(res?.customerStockUsageDescription)
                setNumber(res?.number)
                setPerformerAddressLine(res?.performerAddressLine)
                setPerformerContactLine(res?.performerContactLine)
                setPerformerIdentity(res?.performerIdentity)
                setPerformerName(res?.performerName)
                setSignCustomerFullName(res?.signCustomerFullName)
                setSignCustomerPosition(res?.signCustomerPosition)
                setSignPerfomerFullName(res?.signPerfomerFullName)
                setSignPerfomerPosition(res?.signPerfomerPosition)
                setSignPerformerId(res?.signPerformerId)
                setSignedDateTime(res?.signedDateTime)
                setStartDate(res?.startDate)
                setFilialId(res?.performerId)
                if (client?.personId) {
                    setTypeClient(true)
                    setCustomerId(client?.personId)
                } else if (client?.legalPersonId) {
                    setTypeClient(false)
                    setCustomerId(client?.legalPersonId)
                }

            }
            setService(resService.result[0].id)
            setUnitOfMeasure(resUnit[0].id)
            setLocalServiceKind(resServiceKind[0].id)
            setLoading(false)
        }())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    const [loading, setLoading] = useState(false)
    const [loadingAdd, setLoadingAdd] = useState(false)

    return (
        <Dashboard>
            <BreadcrumbsShared breadcrumbs={[
                {text: 'Акты выполненных работ', link: COMPLETION_ACT_ROUTE},
                {text: 'Добавление акта', link: COMPLETION_ACT_ADD_ROUTE}
            ]}/>
            <Status type={2} status={completionActOne?.state?.name}/>
            {loading ? <Box sx={{
                    minHeight: 556,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}><CircularProgress/></Box> :
                <Box component="form" onSubmit={handleSubmit}>
                    <Box component={Paper}
                         sx={{mt: 5, display: 'flex', padding: '0px 10px', flexWrap: 'wrap'}}>
                        <Typography sx={{margin: '5px 0'}} component="h1" align="center" variant="h5">
                            Заказчик
                        </Typography>
                        <Grid sx={{paddingTop: 2, paddingBottom: 2}} container spacing={2}>
                            <Grid item xs={6}>
                                <Number value={number} setValue={setNumber} label="Номер документа (АКТ)"/>
                            </Grid>
                            <Grid item xs={6}>
                                <DatePickerShared value={startDate} setValue={setStartDate}
                                                  label="Дата составяления"/>
                            </Grid>
                            <Grid item xs={6}>
                                <FormGroup sx={{display: 'flex', justifyContent: 'center'}}>
                                    <Typography>Тип клиента</Typography>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Typography>юр. лицо</Typography>
                                        <Switch onChange={(event) => setTypeClient(event.target.checked)}
                                                checked={typeClient}
                                                inputProps={{'aria-label': 'ant design'}}/>
                                        <Typography>физ. лицо</Typography>
                                    </Stack>
                                </FormGroup>
                            </Grid>
                            <Grid item xs={6}>
                                {typeClient ?
                                    <SelectFieldModal edit func={getPersons} nameFilter="fullName"
                                                      slice={{first: 0, second: 5}}
                                                      rowName={personTableRowName} reduxCount={personsCount}
                                                      reduxValue={persons} label="Физ. лица" value={customerId}
                                                      setValue={setCustomerId}/> :
                                    <SelectFieldModal edit func={getLegalClient} nameFilter="name"
                                                      slice={{first: 0, second: 5}}
                                                      rowName={legalClientTableRowName}
                                                      reduxCount={legalClientReduxCount} reduxValue={legalClientRedux}
                                                      label="Юр. лицо" value={customerId} setValue={setCustomerId}/>}
                            </Grid>
                            <Grid item xs={6}>
                                <TextShared value={customerIdentity} setValue={setCustomerIdentity} label="ИИН/БИН"/>
                            </Grid>
                            <Grid item xs={6}>
                                <TextShared value={customerName} setValue={setCustomerName}
                                            label="Полное наименование"/>
                            </Grid>
                            <Grid item xs={6}>
                                <TextShared value={customerAddressLine} setValue={setCustomerAddressLine}
                                            label="Адрес"/>
                            </Grid>
                            <Grid item xs={6}>
                                <TextShared value={customerContactLine} setValue={setCustomerContactLine}
                                            label="Контакты"/>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box component={Paper}
                         sx={{mt: 5, display: 'flex', padding: '0px 10px', flexWrap: 'wrap'}}>
                        <Typography sx={{margin: '5px 0'}} component="h1" align="center" variant="h5">
                            Исполнитель
                        </Typography>
                        <Grid sx={{paddingTop: 2, paddingBottom: 2}} container spacing={2}>
                            <Grid item xs={6}>
                                <SelectShared array={filial} setValue={setFilialId} value={filialId} label="Филиал"/>
                            </Grid>
                            <Grid item xs={6}>
                                <TextShared value={performerIdentity} setValue={setPerformerIdentity} label="ИИН/БИН"/>
                            </Grid>
                            <Grid item xs={6}>
                                <TextShared value={performerName} setValue={setPerformerName}
                                            label="Полное наименование"/>
                            </Grid>
                            <Grid item xs={6}>
                                <TextShared value={performerAddressLine} setValue={setPerformerAddressLine}
                                            label="Адрес"/>
                            </Grid>
                            <Grid item xs={6}>
                                <TextShared value={performerContactLine} setValue={setPerformerContactLine}
                                            label="Контакты"/>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box component={Paper}
                         sx={{mt: 5, display: 'flex', padding: '0px 10px', flexWrap: 'wrap'}}>
                        <Typography sx={{margin: '5px 0'}} component="h1" align="center" variant="h5">
                            Договор
                        </Typography>
                        <Grid sx={{paddingTop: 2, paddingBottom: 2}} container spacing={2}>
                            <Grid item xs={12}>
                                <SelectFieldModal disabled edit={true} func={getContract} nameFilter="name"
                                                  slice={{first: 0, second: 7}}
                                                  rowName={contractRequestModalRowName}
                                                  reduxCount={contractsCount}
                                                  reduxValue={contracts.map(el => {
                                                      let clientName = ''
                                                      if (el?.client?.personId) {
                                                          clientName = el?.client?.lastName + el?.client?.firstName + el?.client?.middleName
                                                      } else if (el?.client?.legalPersonId) {
                                                          clientName = el?.client?.name
                                                      } else {
                                                          clientName = 'Не задано'
                                                      }
                                                      return {
                                                          id: el.id,
                                                          name: el.name,
                                                          date: moment(el?.actionAt).format('LL'),
                                                          type: el?.type?.name,
                                                          filial: el?.filial?.name,
                                                          client: clientName,
                                                          summary: el.summary
                                                      }
                                                  })}
                                                  label="Договор" value={contractId} setValue={setContractId} args={{
                                    isAdditionalAgreement: {
                                        operand1: false,
                                        operator: "equals"
                                    }
                                }}/>
                            </Grid>
                            <Grid item xs={12}>
                                {RenderTableMin}
                            </Grid>
                            <Grid item xs={6}>
                                <TextShared value={customerStockUsageDescription}
                                            setValue={setCustomerStockUsageDescription}
                                            label="Сведения об использовании запасов, полученных от заказчика"/>
                            </Grid>
                            <Grid item xs={6}>
                                <TextShared value={application}
                                            setValue={setApplication}
                                            label="Приложение"/>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box component={Paper}
                         sx={{mt: 5, display: 'flex', padding: '0px 10px', flexWrap: 'wrap'}}>
                        <Typography sx={{margin: '5px 0'}} component="h1" align="center" variant="h5">
                            Сдал (Исполнитель)
                        </Typography>
                        <Grid sx={{paddingTop: 2, paddingBottom: 2}} container spacing={2}>
                            <Grid item xs={6}>
                                <SelectFieldModal edit rowName={[{text: t("employee.tableItem.id")},
                                    {text: t("employee.tableItem.fullName")}]} setValue={setSignPerformerId}
                                                  value={signPerformerId}
                                                  slice={{first: 0, second: 2}} nameFilter="fullName"
                                                  label="Сдал исполнитель"
                                                  func={getEmployee} reduxValue={employee} reduxCount={employeeCount}/>
                            </Grid>
                            <Grid item xs={6}>
                                <TextShared value={signPerfomerPosition} setValue={setSignPerfomerPosition}
                                            label="Должность"/>
                            </Grid>
                            <Grid item xs={6}>
                                <TextShared value={signPerfomerFullName} setValue={setSignPerfomerFullName}
                                            label="Расшифровка подписи (ФИО)"/>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box component={Paper}
                         sx={{mt: 5, display: 'flex', padding: '0px 10px', flexWrap: 'wrap'}}>
                        <Typography sx={{margin: '5px 0'}} component="h1" align="center" variant="h5">
                            Принял (Заказчик)
                        </Typography>
                        <Grid sx={{paddingTop: 2, paddingBottom: 2}} container spacing={2}>
                            <Grid item xs={6}>
                                <TextShared value={signCustomerPosition} setValue={setSignCustomerPosition}
                                            label="Должность"/>
                            </Grid>
                            <Grid item xs={6}>
                                <TextShared value={signCustomerFullName} setValue={setSignCustomerFullName}
                                            label="Расшифровка подписи (ФИО)"/>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box component={Paper}
                         sx={{mt: 5, display: 'flex', padding: '0px 10px', flexWrap: 'wrap'}}>
                        <Grid sx={{paddingTop: 2, paddingBottom: 2}} container spacing={2}>
                            <Grid item xs={6}>
                                <DatePickerShared value={signedDateTime} setValue={setSignedDateTime}
                                                  label="Дата подписания (принятия) работ (услуг)"/>
                            </Grid>
                        </Grid>
                    </Box>
                    <LoadingButton
                        loading={loadingAdd}
                        type="submit"
                        variant="contained"
                        sx={{mt: 3, mb: 2}}
                    >
                        Изменить акт
                    </LoadingButton>
                </Box>
            }
        </Dashboard>
    );
}

export default CompletionActEdit;